export const libraryStates = {
	DELIVERED: 11,
	DEMO_SOLD: 12,
	DEMO: 13,
	DEMO_CANCELLED: 14,
	DUPLICATE: 15,
	CANCELLED: 16,
};
